import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';

export const Panel = styled.div``;

export const GuestRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space['space-400']} 0 ${space['space-800']};
  border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.subtle};
`;

export const GuestLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const CalendarSection = styled.div`
  padding-top: ${space['space-400']};
`;
